import * as React from "react";
import {PremiumType, UPFRONT_PAYMENT_THRESHOLD} from "@ferry/journey-services";
import {getAmountWithDecimalDigits} from "../../../../../CommonFunctions";
import {MtaSuccessModalWording} from "../yourCarsPage/modal/MtaSuccessModalWording";
import {IFactors} from "../yourCarsPage/modal/GeneratorInputTypes";

export class ClaimImpactMtaSuccessModalWordingGenerator {

    private static defaultModalTitle: string = "Change was successful";


    public static generateModalWording = (factors: IFactors, instalmentPlanMonthlyPremium: number | null,
                                          payFullPrice: boolean, mtaDetailsWording: string | null, cardNumber: string,
                                          agreeToReuseCardDetails: boolean | null): MtaSuccessModalWording => {
        const premiumType: PremiumType = PremiumType[factors.premiumType as keyof typeof PremiumType];

        return new MtaSuccessModalWording(
            ClaimImpactMtaSuccessModalWordingGenerator.generateModalTitle(factors, premiumType, payFullPrice),
            ClaimImpactMtaSuccessModalWordingGenerator.generateModalBody(factors, instalmentPlanMonthlyPremium, premiumType,
                mtaDetailsWording, payFullPrice, cardNumber, agreeToReuseCardDetails),
            "",
            "");

    }

    private static generateModalTitle = (factors: IFactors, premiumType: PremiumType, payFullPrice: boolean): React.ReactNode => {
        const {additionalPremium} = factors;

        if (additionalPremium > 0) {

            switch (premiumType) {
                case PremiumType.annual:
                    return "Payment was successful";
                case PremiumType.monthly:
                    return payFullPrice ? "Payment was successful" : "Payment was successfully added to your monthly payment plan";
                default:
                    return ClaimImpactMtaSuccessModalWordingGenerator.defaultModalTitle;
            }

        } else {
            return ClaimImpactMtaSuccessModalWordingGenerator.defaultModalTitle;
        }
    }

    private static generateModalBody = (factors: IFactors, instalmentPlanMonthlyPremium: number | null,
                                        premiumType: PremiumType, mtaDetailsWording: string | null, payFullPrice: boolean,
                                        cardNumber: string, agreeToReuseCardDetails: boolean | null): React.ReactNode => {

        const {additionalPremium, monthlyPremium, upfrontPaymentAmount, monthlyPaymentSpreadAmount} = factors;


        if (additionalPremium > 0 && (premiumType === PremiumType.annual || payFullPrice) && cardNumber) {
            return (
                <>
                    <p className="mb-0 font-weight-extra-light">
                        <span
                            className="font-weight-semi-bold">{getAmountWithDecimalDigits(additionalPremium)}</span> has
                        been debited from your credit card{" "}
                        ending <span className="font-weight-semi-bold">{cardNumber.slice(-4)}</span>{" "}
                        for paying off a claim outstanding balance.
                    </p>
                    <p>
                        Please allow a couple of minutes for the payment to be updated in your account.
                    </p>
                    {agreeToReuseCardDetails && (
                        <p className="mb-0 font-weight-extra-light">
                            Your future payments will now be taken from this card.
                        </p>
                    )}
                </>
            )
        } else if (additionalPremium > 0 && premiumType === PremiumType.monthly && upfrontPaymentAmount >= UPFRONT_PAYMENT_THRESHOLD && !payFullPrice && cardNumber) {
            return (
                <>
                    <p className="mb-0 font-weight-extra-light">
                        <span
                            className="font-weight-semi-bold">{getAmountWithDecimalDigits(upfrontPaymentAmount)}</span> has
                        been debited from your credit card ending{" "}
                        ending <span className="font-weight-semi-bold">{cardNumber.slice(-4)}</span>{" "}
                        for paying off a claim outstanding balance.
                    </p>
                    <p>
                        Please allow a couple of minutes for the payment to be updated in your account.
                    </p>
                    {agreeToReuseCardDetails && (
                        <p className="mb-0 font-weight-extra-light">
                            Your future payments will now be taken from this card.
                        </p>
                    )}
                    <p className="mb-0 font-weight-extra-light">
                        The remaining {getAmountWithDecimalDigits(monthlyPaymentSpreadAmount)} has been added to your
                        monthly payments.
                    </p>
                </>
            )
        } else if (additionalPremium > 0 && premiumType === PremiumType.monthly && upfrontPaymentAmount < UPFRONT_PAYMENT_THRESHOLD && !payFullPrice) {
            return (
                <>
                    <p className="mb-0 font-weight-extra-light">
                        <span
                            className="font-weight-semi-bold">{getAmountWithDecimalDigits(monthlyPaymentSpreadAmount)}</span> has
                        been added to your monthly payments{" "}
                        for paying off a claim outstanding balance.
                        Your future monthly payments will be <span
                        className="font-weight-semi-bold">{getAmountWithDecimalDigits(monthlyPremium)} / month.</span>
                    </p>
                </>
            )
        } else {
            return "There is no extra cost for the changes you have made.";
        }
    }
}
